import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useContext, useState } from "react";

import { Skeleton } from "@mui/material";
import AnimatedNumber from "../../../Component/AnimatedNumber/AnimatedNumber";
import BrandIndexBreakups from "../../../Component/BrandIndexHistory/BrandIndexBreakups";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import Modal from "../../../Component/Modal/Modal";
import MUICard from "../../../Component/UI/MUICard/MUICard";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { DiscoveryContext } from "../discovery-context";
import { LLM_OPTIONS } from "../../../utils/constant";
import classes from "./MarketComparisonItem.module.css";



export default function MarketItem({
  category,
  brandIndex,
  index,
  market,
  title,
  onRetry = () => {},
}) {
  const [showBrandIndexBreakups, setShowBrandIndexBreakups] = useState(false);
  const llmName = LLM_OPTIONS.find((option) => option.value === title)?.name;

  const discoveryCtx = useContext(DiscoveryContext);

  
 
  let cardContent = "";
  if (category && !brandIndex?.error && brandIndex?.total) {
    cardContent = (
      <>
        {!category && (
          <div className={classes.add_container}>
            <MUIIconButton size="large">
              <AddCircleOutlineOutlinedIcon
                style={{ fontSize: 40 }}
                fontSize="large"
              />
            </MUIIconButton>
          </div>
        )}
        {brandIndex?.extras && (
          <MUIIconButton
            data-html2canvas-ignore
            onClick={() => setShowBrandIndexBreakups(true)}
            className={classes.settings}
          >
            <InfoOutlinedIcon />
          </MUIIconButton>
        )}
        <div className={classes.header}>
          <div className={classes.title_container}>
            <span className={classes.title}>{llmName || market}</span>
           
          </div>
        </div>
        <div className={classes.content}>
          <AnimatedNumber
            className={classes.score}
            start={0}
            end={brandIndex?.total || 0}
            duration={2000}
          />
          <div className={classes.sub_content}>
            <span className={classes.sub_score}>{brandIndex?.rank}</span>
            <hr className={classes.divider} />
            <span className={classes.sub_score}>
              {brandIndex?.favorability}
            </span>
          </div>
        </div>
      </>
    );
  }

  if (category && brandIndex?.error) {
    cardContent = (
      <ErrorView
        title="An error occured"
        message="Something went wrong"
        retry
        onRetry={() => onRetry(index)}
      />
    );
  }

  let categoryCard = "";
  if (cardContent) {
    categoryCard = (
      <MUICard
        variant="elevated"
        elevation={0}
        borderRadius={3}
        className={classes.card}
        width={"90%"}
      >
        {cardContent}
      </MUICard>
    );
  }

  return (
    <div
      className={classes.container}
      id="market_comparison"
      style={{
        backgroundColor: categoryCard ? "#eff4f8" : "inherit",
      }}
    >
      <Modal
        width={1200}
        open={showBrandIndexBreakups}
        handleClose={() => setShowBrandIndexBreakups(false)}
      >
        <BrandIndexBreakups
          data={brandIndex?.extras}
          isOpen={showBrandIndexBreakups}
          type={discoveryCtx.type}
        />
      </Modal>
      {categoryCard}
      {category && !brandIndex?.error && !brandIndex?.total && (
        <Skeleton
          variant="rectangular"
          style={{
            zIndex: 1,
            flexGrow: 1,
            height: 220,
            flexBasis: "calc(50% - 12.5px)",
            backgroundColor: "rgb(0 0 0 / 11%)",
          }}
        />
      )}
    </div>
  );
}
